import { cva, type VariantProps } from "class-variance-authority";
import { XIcon } from "lucide-react";
// oxlint-disable-next-line eslint/no-restricted-imports this wrapper is the canonical way to call sonner in the app.
import { type ToasterProps, toast } from "sonner";

import { cn } from "@/web/lib/styling";

export function toaster({
  message,
  sonnerOptions,
  ...variants
}: {
  message: string;
  sonnerOptions?: ToasterProps;
} & VariantProps<typeof toastVariants>) {
  return toast.custom((t) => <ToastBody toastId={t} message={message} {...variants} />, {
    ...sonnerOptions,
  });
}

export function dismissToast(toastId?: string | number) {
  toast.dismiss(toastId);
}

const toastVariants = cva(
  "flex items-center justify-between shadow-[0px_0px_20px_0px_rgba(0,0,0,0.25)] mb-2",
  {
    variants: {
      variant: {
        dark: "bg-withus-dark-blue text-withus-pure-white",
        light: "bg-card text-withus-dark-blue",
        success: "bg-card text-withus-green",
        error: "bg-card text-withus-red",
      },
    },
    defaultVariants: {
      variant: "dark",
    },
  },
);

function ToastBody({
  toastId,
  message,
  ...variants
}: {
  toastId: string | number;
  message: string;
} & VariantProps<typeof toastVariants>) {
  return (
    <div className={cn(toastVariants(variants))}>
      <div className="p-4 md:text-sm">{message}</div>
      <button
        className="flex cursor-pointer items-center justify-center border-l-2 border-current/10 p-4 text-current/50"
        onClick={() => toast.dismiss(toastId)}
        type="button"
      >
        <XIcon className="size-4" />
      </button>
    </div>
  );
}
